<div class="lead-search">
  <div class="flex">
    <ui-icon
      name="search"
      size="20"
      mSize="20"
      fill="neutrals-600"
      class="relative z-9 top-[10px] left-7"
    />
    <input
      class="w-full h-[40px] min-h-[40px] max-h-[40px] box-border py-2 bg-neutrals-0 rounded-[8px] border-neutrals-400 pr-3 pl-9 cursor-pointer"
      type="text"
      [value]="value"
      placeholder="Buscar..."
      readonly
      (focus)="onShowSearch()"
    />
  </div>
  <div
    class="z-10 fixed top-[60px] left-0 right-0 bottom-0 flex items-center bg-[#0B2C56] bg-opacity-20"
    *ngIf="showSearch"
  >
    <div
      class="bg-white w-full max-h-[450px] top-[48px] h-[380px] pl-[120px] pt-[42px] pb-[40px] pr-[60px]"
      [ngClass]="{
        relative: !showSearch,
        fixed: showSearch,
      }"
    >
      <div class="flex justify-between mb-9">
        <div class="input-search flex -ml-[20px] w-6/12">
          <ui-icon
            name="search"
            size="20"
            mSize="20"
            fill="neutrals-600"
            class="relative z-9 top-[10px] left-7"
          />
          <input
            class="w-full h-[40px] min-h-[40px] max-h-[40px] box-border py-2 bg-neutrals-0 rounded-[8px] border-neutrals-400 pr-3 pl-9 cursor-pointer focus:border-2 focus:border-solid focus:border-[#d2def1]"
            type="text"
            placeholder="Buscar nombres, distrito, celular..."
            [(ngModel)]="valueSearch"
            (input)="onSearch($event)"
          />
        </div>
        <button (click)="onClose()">
          <ui-icon
            name="close"
            size="20"
            mSize="20"
            fill="neutrals-600"
            class=""
          />
        </button>
      </div>
      <div class="flex flex-col">
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          text-color="neutrals-700"
          font-weight="regular"
          class="mb-4"
        >
          Resultados ({{ leads.length }})
        </ui-paragraph>
        <div
          class="overflow-y-auto overflow-hidden flex flex-col max-h-[200px]"
          *ngIf="!isLoading"
        >
          <div
            class="w-full hover:bg-[#EDF4FB] px-2 py-2 cursor-pointer"
            *ngFor="let lead of leads"
          >
            <button
              class="flex items-center gap-4"
              (click)="onShowChatLead(lead)"
            >
              <ui-paragraph
                class="mr-2"
                type="p14"
                mobile-type="p14"
                text-color="neutrals-900"
                font-weight="regular"
              >
                {{ lead.leadCompleteName }}
              </ui-paragraph>
              <div
                class="flex justify-center items-center rounded-2xl bg-[#E2EAF6] px-4 py-1"
              >
                <ui-paragraph
                  type="p12"
                  mobile-type="p12"
                  text-color="neutrals-900"
                  font-weight="semibold"
                >
                  {{ lead.orderStatusName }}
                </ui-paragraph>
              </div>
            </button>
          </div>
        </div>
        <div *ngIf="isLoading" class="flex items-center justify-center py-9">
          <ui-loader type="primary" size="2xl" />
        </div>
      </div>
    </div>
  </div>
</div>
